import { MemberDto } from '@/services/api'
import { MemberRoleEnumLabels } from './constants'

export const getNameWithRole = (member: MemberDto) => {
  if (!member) {
    return ''
  }
  const roleLabel = MemberRoleEnumLabels[member.role]
  return `${member.firstName} ${member.lastName}${
    roleLabel ? ` (${roleLabel})` : ''
  }`
}
